import React from "react";
import MaintenanceContractDetails from "./MaintenanceContractDetails";
import Contact from "../../common/Contact/Contact";
import FooterThree from "../../common/Footer/FooterThree";
import Menu from "../../common/Menu/Menu";
import MaintenanceContractBanner from "./MaintenanceContractBanner";

const MaintenanceContract = () => {
    return (
        <>
      <Menu header_style_2={true} />
      <MaintenanceContractBanner />
      <MaintenanceContractDetails />
      <Contact />
      <FooterThree />
    </>
    )
}
export default MaintenanceContract;